import { useTheme } from '@mui/material'
import type { ReactNode } from 'react'
import { memo } from 'react'

export interface InvoiceRowProps {
  label: ReactNode
  value: ReactNode
  actions?: ReactNode
  divider?: boolean
  spacing?: number
}

const InvoiceRow = ({ label, value, actions, spacing: pSpacing, divider = false }: InvoiceRowProps) => {
  const { spacing } = useTheme()
  const paddingBottom = pSpacing ? spacing(pSpacing) : undefined
  return (
    <tr>
      <td style={{ paddingBottom }}>{label}</td>
      <td style={{ paddingBottom, borderTopWidth: divider ? 1 : undefined, textAlign: 'right' }}>{value}</td>
      <td style={{ paddingBottom }}>{actions}</td>
    </tr>
  )
}

export default memo(InvoiceRow)
